import './styles.scss';
import React from 'react';
import {Card, Col, Row, Statistic} from "antd";
import OpportunitiesTable from "../Opportunities.table/Opportunities.table.component";
import {IAlertAnalytics} from "../../../api/Analytics/Analytics.types";

interface Props {
    alertAnalytics:IAlertAnalytics,
}

function AlertDetails({alertAnalytics:data}: Props) {

    return (
        <div className='alert-details'>
            <Row gutter={24} style={{marginBottom: 24}}>
                {/*<Col span={12}>*/}
                {/*    <Card>*/}
                {/*        <Statistic*/}
                {/*            title="Total Contracts"*/}
                {/*            value={data.totalContracts}*/}
                {/*            valueStyle={{color: '#3f8600'}}*/}
                {/*        />*/}
                {/*    </Card>*/}
                {/*</Col>*/}
                <Col span={24}>
                    <Card>
                        <Statistic
                            title="Total Opportunities"
                            value={data.totalOpportunities}
                            valueStyle={{color: '#3f8600'}}
                        />
                    </Card>
                </Col>
            </Row>
            {/*<Row>*/}
            {/*    <Col span={24}>*/}
            {/*        <div className='card-title'>*/}
            {/*            Most Recent Contracts*/}
            {/*        </div>*/}
            {/*        <ContractsTable data={data.contracts} pagination={false}/>*/}
            {/*    </Col>*/}

            {/*</Row>*/}
            <Row style={{marginTop: 24}}>
                <Col span={24}>
                    <div className='card-title'>
                        Alert Opportunities
                    </div>
                    <OpportunitiesTable data={data.opportunities} pagination={{
                        pageSize: 10
                    }}/>
                </Col>
            </Row>
        </div>
    )
}

export default AlertDetails;